import React from 'react';
import SortProducts from "../Category/SortProducts/SortProducts";
import PageSize from "../Category/PageSize/PageSize";

const ListingNav = ({showSorting=true, children}) => {
    return (
        <div className="category__sort">
            <PageSize />
            {children}
            {showSorting && <SortProducts />}
        </div>
    )
}

export default ListingNav
